import React from "react"
import { twMerge } from "tailwind-merge"

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string
  variant?: "small" | "regular"
  children?: React.ReactNode
  busy?: boolean
}

export const buttonBasicStyles = `min-h-[52px] 
        inline-flex flex-row items-center justify-center 
        rounded-lg 
        font-bricolage text-[24px] lg:text-[28px] text-center font-extrabold
        px-6 py-0 cursor-pointer
        focus-visible:outline focus-visible:outline-2 
        focus-visible:outline-offset-2 
        active:scale-95
        border`

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, variant, disabled, busy, ...props }, ref) => {
    const sizeStyles = variant === "small" ? "min-h-[48px] px-5 text-[24px]" : "min-h-[52px] px-6"
    return (
      <button
        ref={ref}
        className={twMerge(buttonBasicStyles, sizeStyles, className)}
        disabled={disabled || busy}
        {...props}>
        {children}
      </button>
    )
  },
)

Button.displayName = "Button"
export default Button
